import * as openpgp from 'openpgp'

const decrypt = async (
  ciphertext: string,
  secretKey: string,
  withError = false,
) => {
  try {
    const message = await openpgp.readMessage({
      armoredMessage: ciphertext,
    })
    const decrypted = await openpgp.decrypt({
      message,
      passwords: [secretKey],
    })

    const originalData = decrypted.data as string

    // Check if the result is empty
    if (!originalData) {
      throw new Error('Decryption failed: Empty result')
    }

    return originalData
  } catch (error) {
    if (withError) {
      throw error
    }
    return '' // or return null, or throw the error based on your needs
  }
}

export default decrypt
